import { useId, type JSX } from 'react';
import { Input } from '@/components/ui';
import { cn } from '@/lib/utils';
import { statusToneInteractiveFieldClasses } from '@/lib/statusTone';

export function YearField({
  id,
  value,
  onChange,
  disabled = false,
  placeholder,
  error,
}: {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
}): JSX.Element {
  const fallbackId = useId();
  const resolvedId = id ?? fallbackId;
  const errorClasses = error ? statusToneInteractiveFieldClasses('danger') : [];

  // Parse year from various formats
  const parseYear = (val: string | undefined | null): string => {
    if (!val) return '';
    const trimmed = val.trim();
    // If it's already just a year
    if (/^\d{4}$/.test(trimmed)) return trimmed;
    // If it's ISO date format
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed.split('-')[0];
    // If it's ISO month format
    if (/^\d{4}-\d{2}$/.test(trimmed)) return trimmed.split('-')[0];
    return trimmed;
  };

  const yearValue = parseYear(value);

  return (
    <Input
      id={resolvedId}
      inputMode="numeric"
      pattern="\\d{4}"
      maxLength={4}
      placeholder={placeholder ?? 'Es: 2026'}
      value={yearValue}
      disabled={disabled}
      onChange={(event) => {
        // Only allow numeric characters
        const nextYear = event.target.value.replace(/\D/g, '');
        onChange?.(nextYear);
      }}
      className={cn(...errorClasses)}
    />
  );
}
